function updateGeolocationLinkNames(){
  document.querySelectorAll('a[href="#geolocation-link"]').forEach((link) => {
    if(get_is_venue_user_selected()){
      const venue = get_current_venue_info();
      
      link.href = venue.url;

      if(link.querySelector('span')){
        link.querySelector('span').innerHTML = venue.name;
      }else{
        link.innerHTML = venue.name;
      }
    }
  });
}

document.querySelectorAll('a[href="#geolocation-link"]').forEach((link) => {
  link.classList.add('replace-with-venue-name');

  link.addEventListener('click', (event) => {
    event.preventDefault();

    link.disabled = true;
    link.classList.add('pointer-events-none', 'animate-pulse');

    set_venue_by_coordinates(() => {
      link.disabled = false;
      link.classList.remove('pointer-events-none', 'animate-pulse');
      updateGeolocationLinkNames();
    });
  });
});

document.querySelectorAll('a[href="#geolocation"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    link.disabled = true;
    link.classList.add('pointer-events-none', 'animate-pulse');

    set_venue_by_coordinates(() => {
      link.disabled = false;
      link.classList.remove('pointer-events-none', 'animate-pulse');
    });
  });
});

updateGeolocationLinkNames();
document.body.addEventListener('venueChanged', updateGeolocationLinkNames);